<template>
  <v-dialog
    :modelValue="open"
    @update:modelValue="open = $event"
    max-width="420"
  >
    <v-card>
      <v-toolbar>
        <v-toolbar-title>Delete Connection</v-toolbar-title>
        <v-btn variant="text" icon color="grey" @click="$emit('close')">
          <v-icon >mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="py-0 mt-4">
        There are more than one connection that can be deleted, which one do you want to deleted?
        <v-list>
          <v-list-item
            v-for="(target, i) in connections"
            :key="i"
            @click="$emit('delete-connection', target.parentId, target.childId)"
          >
            <v-list-item-title>{{ target.eventName }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          variant="outlined"
          size="large"
          @click="$emit('close')">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: Boolean,
    connections: Array
  }
}
</script>
